import { useAppDownloadRedirectUrl } from '@/hooks/useAppDownloadRedirectUrl';
import {
    AppDownloadSource,
    type AppDownloadSourceValue,
    AppDownloadTrigger,
} from '@/utils/urls/appDownloadRedirectUrl';

import { DownloadMobilePromoDesktop, DownloadMobilePromoMobile } from './components';

export type DownloadMobilePromoDevice = 'desktop' | 'mobile';

export type Props = {
    className?: string;
    device: DownloadMobilePromoDevice;
    onClose: () => void;
    onGetApp?: () => void;
    /** Analytics `source` query param on the app store redirect (defaults to leading bidder). */
    source?: AppDownloadSourceValue;
};

export const DownloadMobilePromo = ({
    className,
    device,
    onClose,
    onGetApp,
    source = AppDownloadSource.LeadingBidder,
}: Props) => {
    const qrDownloadUrl = useAppDownloadRedirectUrl({ source, trigger: AppDownloadTrigger.QrScan });
    const mobileDownloadUrl = useAppDownloadRedirectUrl({ source, trigger: AppDownloadTrigger.MobileCtaClick });

    if (device === 'mobile') {
        return (
            <DownloadMobilePromoMobile
                className={className}
                downloadUrl={mobileDownloadUrl}
                onClose={onClose}
                onGetApp={onGetApp}
                source={source}
            />
        );
    }

    return (
        <DownloadMobilePromoDesktop
            className={className}
            downloadUrl={qrDownloadUrl}
            onClose={onClose}
            source={source}
        />
    );
};
